/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationInfosListEventInvitationInfosData model module.
 * @module model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationInfosListEventInvitationInfosData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationInfosListEventInvitationInfosData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationInfosListEventInvitationInfosData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData} The populated <code>EventsControllerDtoEventInvitationInfosListEventInvitationInfosData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationInfosListEventInvitationInfosData();

            if (data.hasOwnProperty('invNo')) {
                obj['invNo'] = ApiClient.convertToType(data['invNo'], 'Number');
            }
            if (data.hasOwnProperty('invitationLimit')) {
                obj['invitationLimit'] = ApiClient.convertToType(data['invitationLimit'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('xperUsed')) {
                obj['xperUsed'] = ApiClient.convertToType(data['xperUsed'], 'Number');
            }
            if (data.hasOwnProperty('perUsed')) {
                obj['perUsed'] = ApiClient.convertToType(data['perUsed'], 'Number');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('eventType')) {
                obj['eventType'] = ApiClient.convertToType(data['eventType'], 'Number');
            }
            if (data.hasOwnProperty('initialPer')) {
                obj['initialPer'] = ApiClient.convertToType(data['initialPer'], 'Number');
            }
            if (data.hasOwnProperty('balancePer')) {
                obj['balancePer'] = ApiClient.convertToType(data['balancePer'], 'Number');
            }
            if (data.hasOwnProperty('rewardRatio')) {
                obj['rewardRatio'] = ApiClient.convertToType(data['rewardRatio'], 'Number');
            }
            if (data.hasOwnProperty('rewardLimit')) {
                obj['rewardLimit'] = ApiClient.convertToType(data['rewardLimit'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationInfosListEventInvitationInfosData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationInfosListEventInvitationInfosData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} invNo
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['invNo'] = undefined;

/**
 * @member {Number} invitationLimit
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['invitationLimit'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['regDuration'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['createdAt'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['initialXper'] = undefined;

/**
 * @member {Number} balanceXper
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['balanceXper'] = undefined;

/**
 * @member {Number} xperUsed
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['xperUsed'] = undefined;

/**
 * @member {Number} perUsed
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['perUsed'] = undefined;

/**
 * @member {Number} walletNo
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['walletNo'] = undefined;

/**
 * @member {Number} userCount
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['userCount'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Number} eventType
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['eventType'] = undefined;

/**
 * @member {Number} initialPer
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['initialPer'] = undefined;

/**
 * @member {Number} balancePer
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['balancePer'] = undefined;

/**
 * @member {Number} rewardRatio
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['rewardRatio'] = undefined;

/**
 * @member {Number} rewardLimit
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['rewardLimit'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoEventInvitationInfosListEventInvitationInfosData.prototype['enabled'] = undefined;






export default EventsControllerDtoEventInvitationInfosListEventInvitationInfosData;

